import FuseSplashScreen from '@fuse/core/FuseSplashScreen';
import * as userActions from 'app/auth/store/actions';
import * as Actions from 'app/store/actions';
import { AuthService } from 'app/services';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import history from '@history';
import { noSyncDataItem } from 'app/fuse-configs/navigationConfig';
import { LAST_ACTIVITY_TIME_KEY } from 'components/IdleTimer/constants';

const SYNC_STATUS = {
  NONE: 0,
  SYNCED: 1,
  NOT_SYNCED: 2,
};

const TIMEOUT_CHECK_AUTH = 5 * 60000;

const FRED_DISPENSE_PLUS = 13;
class Auth extends Component {
  state = {
    waitAuthCheck: true,
  };

  componentDidMount() {
    this.authCheck()
      .then((isAuth) => {
        if (isAuth) {
          return this.props.getUserProfile();
        }
        return true;
      })
      .then(() => {
        this.setState({ waitAuthCheck: false });
      })
      .catch((e) => {
        console.log('eeee', e);
      });

    // listen to login success event
    AuthService.on('loginSuccess', (needToChangePassword) => {
      this.props.getUserProfile().then(() => {
        if (needToChangePassword) {
          history.replace('/auth/change-password');
        } else {
          history.replace('/home');
        }
      });
    });
  }

  componentDidUpdate() {
    const { syncStatus, dispensingSystem } = this.props;
    if (syncStatus === SYNC_STATUS.SYNCED && dispensingSystem !== FRED_DISPENSE_PLUS) {
      this.props.resetNavigation();
      return;
    }
    if (syncStatus === SYNC_STATUS.SYNCED && dispensingSystem !== FRED_DISPENSE_PLUS) {
      this.props.updateNavigationItem('sync', noSyncDataItem, 'navigationBottomConfig');
      return;
    }
    this.props.removeNavigationItem('sync', 'navigationBottomConfig');
    this.props.removeNavigationItem('noSync', 'navigationBottomConfig');
  }

  authCheck() {
    return new Promise((resolve) => {
      const lastActivityTime = window.localStorage.getItem(LAST_ACTIVITY_TIME_KEY);
      if (Number(lastActivityTime) < Number(Date.now() - TIMEOUT_CHECK_AUTH)) {
        // auto log out after 5 minute
        resolve(false);
      } else {
        AuthService.on('checkSuccess', () => {
          resolve(true);
        });

        AuthService.on('checkFailed', () => {
          this.props.logout();
          resolve(false);
        });

        AuthService.checkAuth();
      }

      return Promise.resolve();
    });
  }

  render() {
    return this.state.waitAuthCheck ? <FuseSplashScreen /> : <>{this.props.children}</>;
  }
}
function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      logout: userActions.logoutUser,
      setUserData: userActions.setUserData,
      showMessage: Actions.showMessage,
      hideMessage: Actions.hideMessage,
      setRole: userActions.setRole,
      getUserProfile: userActions.getUserProfile,
      updateNavigationItem: Actions.updateNavigationItem,
      removeNavigationItem: Actions.removeNavigationItem,
      resetNavigation: Actions.resetNavigation,
    },
    dispatch,
  );
}
function mapStateToProps({ auth }) {
  return {
    syncStatus: auth.user.syncStatus,
    dispensingSystem: auth.user.dispensingSystem,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Auth);
